export enum WidgetType {
  PIE = 'Pie',
  MAP = 'Map',
  LIST = 'List',
}
